export function HtmlGit(){

    return(

        <>
        <h1>Hello Git </h1>
        </>
    )
}

export default HtmlGit;